<template>
  <div class="vm-block-door">
    <!-- <div
      v-if="user_id"
      class="fs20 fwb pl-0-16 pr-0-16 mq flex-box flex-justify-content-space-between flex-align-items-center"
    >-->
    <div v-if="user_id" class="door-item flex-box flex-wrap" :class="[browser_size]">
      <template v-for="(item, i) in list[user_id]">
        <router-link class="item block" :key="i" :to="`${item.path}`">
          <div
            class="inner-box darkbg"
            :style="{backgroundImage:`url(${$img_src({src:`${GL.PIC_HOST}${item.cover}`,width:320,height:320})})`}"
          >
            <!-- <pic v-if="item.cover" class="self-center" :src="item.cover" width="320" height="320" /> -->
          </div>
          <div class="mt16 tit gl-hover-text-purple">{{item.title}}</div>
        </router-link>
      </template>
    </div>
    <!-- </div> -->
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  name: 'block-door',
  props: {
    user_id: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      list: {
        '3477946af5a511eab08752540025c377': [
          {
            path: '/a/leftright2018',
            cover:
              '/static/img/links/179f19102e7111e8bf4d52540025c377/huzuohuyou.png',
            title: '忽左忽右',
          },
          {
            path: '/a/tipsyproof',
            cover:
              '/static/img/links/179f19102e7111e8bf4d52540025c377/beigongsheyin.png',
            title: '杯弓舌瘾',
          },
          {
            path: '/a/TheWeirdo',
            cover:
              '/static/img/links/179f19102e7111e8bf4d52540025c377/buheshiyi.png',
            title: '不合时宜',
          },
          {
            path: '/a/eyeoneastasia',
            cover:
              '/static/img/links/179f19102e7111e8bf4d52540025c377/guancha.png',
            title: '东亚观察局',
          },
        ],
      },
    };
  },
  computed: {
    ...mapState('app', ['session_user', 'browser_size']),
    ...mapState('user', ['this_user']),
    is_self() {
      return (
        this.session_user && this.this_user.user_id == this.session_user.user_id
      );
    },
  },
  watch: {},
  async mounted() {
    // await this.$store.dispatch("app/get:goal_list");
    // if (this.goal_list.length == 0) {
    // }
    // if (this.this_user) {
    //   this.get_album_list();
    // } else {
    //   console.log('缺少依赖this_user');
    // }
  },
  methods: {},
};
</script>

<style lang="stylus" scoped>
.vm-block-door {
  .door-item {
    margin-bottom: 24px;

    .inner-box {
      box-shadow: $layer-shadow;
    }

    &.small {
      margin-top: 16px;

      .tit {
        font-size: 16px;
      }

      .item {
        width: calc(50% - 8px);
        margin-bottom: 24px;

        &:nth-child(3n) {
          margin-right: 16px;
        }

        &:nth-child(2n) {
          margin-right: 0px;
        }

        &:nth-child(n+4) {
          margin-top: 0px;
        }
      }
    }

    .tit {
      font-size: 24px;
    }

    .item {
      flex-shrink: 0;
      height: auto;
      cursor: pointer;
      margin-right: 16px;
      width: calc(33.33% - 11px);

      // margin-bottom: 64px;
      &:nth-child(n+4) {
        margin-top: 24px;
      }

      &:nth-child(3n) {
        margin-right: 0px;
      }

      &:hover {
        .inner-box {
          background-color: rgba(234, 234, 234, 0.8);
        }
      }

      .inner-box {
        background: rgba(234, 234, 234, 1);
        padding-bottom: 100%;
        position: relative;
        height: auto;
        border-radius: 8px;
        background-size: cover;

        img {
          border-radius: 8px;
        }
      }

      i {
        color: $white;
        font-size: 60px;
      }
    }
  }

  @media (max-width: $width-mobile) {
    .door-item {
      background: $white;
      margin-bottom: 0;
    }
  }
}
</style>
